<script>
export default {
    inject: {
        searchbar: {
            from: 'searchbar',
            default: null,
        },
    },
    props: {
        context: {
            type: String,
            default: '',
        },
        link: {
            type: String,
            default: '',
        },
        uuid: {
            type: String,
            required: true,
        },
        highlightedExtraFields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isHovered: false,
        };
    },
    computed: {
        getHighlightedExtraFields() {
            return this.highlightedExtraFields
                .map((field) => {
                    if (field.value) {
                        return field;
                    }
                })
                .filter((field) => field);
        },
    },
    created() {
        try {
            this.searchbar?.searchResultsAsComponents.push(this);
        } catch (e) {
            console.error(e);
        }
    },
    methods: {
        handleMouseEnter() {
            if (this.searchbar) {
                const componentIndex = this.searchbar.flatSearchResults.findIndex(
                    (element) => element.uuid === this.uuid,
                );
                this.searchbar.hoverIndex = componentIndex;
                this.searchbar.searchResultsAsComponents.map((result) => {
                    result.isHovered = result.uuid === this.uuid;
                    return result;
                });
            }
        },
    },
};
</script>
